import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles(() =>
  createStyles({
    root: {
      display: 'inline-block',
      position: 'relative',
    },
    track: {
      transform: 'rotate(-200deg)',
      transformOrigin: '50% 50%',
    },
    progress: {
      transition: 'stroke-dashoffset 0.35s',
      transform: 'rotate(-200deg)',
      transformOrigin: '50% 50%',
    },
    progressText: {
      fontSize: '2rem',
      position: 'absolute',
      top: '35%',
      left: '50%',
      transform: 'translate(-50%, -35%)',
    },
    label: {
      fontSize: '1.2rem',
      fontWeight: 500,
      position: 'absolute',
      top: '80%',
      left: '50%',
      transform: 'translate(-50%, -80%)',
    },
  })
)
